import { SectionHeader, BfiCustomStore, Accordion } from '../common/SharedComponents';
import TwentyPercentOwnerCommercialRulesTable from './tables/TwentyPercentOwnerCommercialRulesTable';
import TwentyPercentOwnerResidentialRulesTable from './tables/TwentyPercentOwnerResidentialRulesTable';
import LicensedGCRulesTable from './tables/LicensedGCRulesTable';
import SupplementalRulesTable from './tables/SupplementalRulesTable';
import RuleModal from './modals/RuleModal';
import SupplementalRuleModal from './modals/SupplementalRuleModal';

const ExperienceRulesLanding = () => {
    const gridStore1 = new BfiCustomStore();
    const gridStore2 = new BfiCustomStore();
    const gridStore3 = new BfiCustomStore();
    const gridStore4 = new BfiCustomStore();

    return (
        <>
            <SectionHeader title='Experience Rules' />
            <div
                className='main-content no-search'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div
                    className='scrollable-content-without-search'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <Accordion
                            title='Experience As 20%+ Owner'
                            isExpanded={true}
                            id={`20PercentOwnerExperience`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <div style={{ padding: '8px' }}>Residential</div>
                                    <TwentyPercentOwnerResidentialRulesTable gridStore={gridStore1} />
                                </div>
                            </div>
                            <div className='card'>
                                <div className='card-section'>
                                    <div style={{ padding: '8px' }}>Commercial</div>
                                    <TwentyPercentOwnerCommercialRulesTable gridStore={gridStore2} />
                                </div>
                            </div>
                        </Accordion>
                        <Accordion
                            title='Supplemental'
                            isExpanded={true}
                            id={`SupplementalExperience`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <SupplementalRulesTable gridStore={gridStore3} />
                                </div>
                            </div>
                        </Accordion>
                        <Accordion
                            title='Experience As Licensed GC'
                            isExpanded={true}
                            id={`LicensedGCExperience`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <div style={{ padding: '8px' }}>Residential</div>
                                    <LicensedGCRulesTable gridStore={gridStore4} />
                                </div>
                            </div>
                        </Accordion>
                    </div>
                </div>
            </div>
            <RuleModal />
            <SupplementalRuleModal />
        </>
    );
};

export default ExperienceRulesLanding;
